import { type LanguagsDataSet } from '../datasets/language';
import useAsyncImportDataSets from './useAsyncImportDataSets';

const useLanguageList = () => {
    const { loading, data } = useAsyncImportDataSets('language');

    return { loading, data: (data ?? []) as LanguagsDataSet };
};

export default useLanguageList;
